import Notify from "./notifyActions";

function isResponseError(response) {
  return response && response.payload && response.payload.data && response.payload.data.success === false;
}

export const SMART_FLAG_PROFILES_GET = 'SMART_FLAG_PROFILES_GET'

export const getSmartFlagProfiles = (organisationId) => ({
  type: SMART_FLAG_PROFILES_GET,
  payload: {
    request: {
      mode: "no-cors",
      url: `smart-flag-profile?organisationId=${organisationId}`,
      method: "GET"
    }
  }
});

export const SMART_FLAG_PROFILE_DETAIL_GET = 'SMART_FLAG_PROFILE_DETAIL_GET'

export const getSmartFlagProfileDetail = (id) => ({
  type: SMART_FLAG_PROFILE_DETAIL_GET,
  payload: {
    request: {
      mode: "no-cors",
      url: `smart-flag-profile/${id}`,
      method: "GET"
    }
  }
});

export const SMART_FLAG_PROFILE_CREATE = 'SMART_FLAG_PROFILE_CREATE'
export const SMART_FLAG_PROFILE_CREATE_SUCCESS_TOAST = 'smart_flag_profile_create_success_toast'
export const SMART_FLAG_PROFILE_CREATE_FAIL_TOAST = 'smart_flag_profile_create_fail_toast'

export const createSmartFlagProfile = (data) => {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: SMART_FLAG_PROFILE_CREATE,
        payload: {
          request: {
            mode: "no-cors",
            url: 'smart-flag-profile',
            method: "POST",
            data: data
          }
        }
      }).then(response => {
        if (isResponseError(response)) {
          dispatch(Notify.error(SMART_FLAG_PROFILE_CREATE_FAIL_TOAST));
        } else {
          dispatch(Notify.success(SMART_FLAG_PROFILE_CREATE_SUCCESS_TOAST));
        }
        resolve(response);
      }).catch(err => {
        dispatch(Notify.error(SMART_FLAG_PROFILE_CREATE_FAIL_TOAST));
        reject(err);
      });
    });
  };
};

export const SMART_FLAG_PROFILE_UPDATE = 'SMART_FLAG_PROFILE_UPDATE'
export const SMART_FLAG_PROFILE_UPDATE_SUCCESS_TOAST = 'smart_flag_profile_update_success_toast'
export const SMART_FLAG_PROFILE_UPDATE_FAIL_TOAST = 'smart_flag_profile_update_fail_toast'

export const updateSmartFlagProfile = (id, data) => {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: SMART_FLAG_PROFILE_UPDATE,
        payload: {
          request: {
            mode: "no-cors",
            url: `smart-flag-profile/${id}`,
            method: "PUT",
            data: data
          }
        }
      }).then(response => {
        if (isResponseError(response)) {
          dispatch(Notify.error(SMART_FLAG_PROFILE_UPDATE_FAIL_TOAST));
        } else {
          dispatch(Notify.success(SMART_FLAG_PROFILE_UPDATE_SUCCESS_TOAST));
        }
        resolve(response);
      }).catch(err => {
        dispatch(Notify.error(SMART_FLAG_PROFILE_UPDATE_FAIL_TOAST));
        reject(err);
      });
    });
  };
};

export const SMART_FLAG_PROFILE_DELETE = 'SMART_FLAG_PROFILE_DELETE'
export const SMART_FLAG_PROFILE_DELETE_SUCCESS_TOAST = 'smart_flag_profile_delete_success_toast'
export const SMART_FLAG_PROFILE_DELETE_FAIL_TOAST = 'smart_flag_profile_delete_fail_toast'

export const deleteSmartFlagProfile = (id) => {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: SMART_FLAG_PROFILE_DELETE,
        payload: {
          request: {
            mode: "no-cors",
            url: `smart-flag-profile/${id}`,
            method: "DELETE"
          }
        }
      }).then(response => {
        if (isResponseError(response)) {
          dispatch(Notify.error(SMART_FLAG_PROFILE_DELETE_FAIL_TOAST));
        } else {
          dispatch(Notify.success(SMART_FLAG_PROFILE_DELETE_SUCCESS_TOAST));
        }
        resolve(response);
      }).catch(err => {
        dispatch(Notify.error(SMART_FLAG_PROFILE_DELETE_FAIL_TOAST));
        reject(err);
      });
    });
  };
};

export const SMART_FLAG_PROFILE_SET_DEFAULT = 'SMART_FLAG_PROFILE_SET_DEFAULT'
export const SMART_FLAG_PROFILE_SET_DEFAULT_SUCCESS_TOAST = 'smart_flag_profile_set_default_success_toast'
export const SMART_FLAG_PROFILE_SET_DEFAULT_FAIL_TOAST = 'smart_flag_profile_set_default_fail_toast'

export const setSmartFlagProfileDefault = (profileId, organisationId, isDefault) => {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: SMART_FLAG_PROFILE_SET_DEFAULT,
        payload: {
          request: {
            mode: "no-cors",
            url: 'smart-flag-profile/set-default',
            method: "POST",
            data: {
              profileId: profileId,
              organisationId: organisationId,
              isDefault: isDefault
            }
          }
        }
      }).then(response => {
        if (isResponseError(response)) {
          dispatch(Notify.error(SMART_FLAG_PROFILE_SET_DEFAULT_FAIL_TOAST));
        } else {
          dispatch(Notify.success(SMART_FLAG_PROFILE_SET_DEFAULT_SUCCESS_TOAST));
        }
        resolve(response);
      }).catch(err => {
        dispatch(Notify.error(SMART_FLAG_PROFILE_SET_DEFAULT_FAIL_TOAST));
        reject(err);
      });
    });
  };
};

export const SMART_FLAG_PROFILE_CLONE = 'SMART_FLAG_PROFILE_CLONE'
export const SMART_FLAG_PROFILE_CLONE_SUCCESS_TOAST = 'smart_flag_profile_clone_success_toast'
export const SMART_FLAG_PROFILE_CLONE_FAIL_TOAST = 'smart_flag_profile_clone_fail_toast'

export const cloneSmartFlagProfile = (sourceProfileId, newName) => {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: SMART_FLAG_PROFILE_CLONE,
        payload: {
          request: {
            mode: "no-cors",
            url: 'smart-flag-profile',
            method: "POST",
            data: {
              name: newName,
              sourceProfileId: sourceProfileId
            }
          }
        }
      }).then(response => {
        if (isResponseError(response)) {
          dispatch(Notify.error(SMART_FLAG_PROFILE_CLONE_FAIL_TOAST));
        } else {
          dispatch(Notify.success(SMART_FLAG_PROFILE_CLONE_SUCCESS_TOAST));
        }
        resolve(response);
      }).catch(err => {
        dispatch(Notify.error(SMART_FLAG_PROFILE_CLONE_FAIL_TOAST));
        reject(err);
      });
    });
  };
};

export const SMART_FLAG_PROFILE_RESET = 'SMART_FLAG_PROFILE_RESET'

export const resetSmartFlagProfileDetail = () => ({
  type: SMART_FLAG_PROFILE_RESET
});
